/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {franchiseInvoiceCurrentUsage} from '../core/_models'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'
import {InvoiceLogModal} from './invoiceHistoryList/components/modal/InvoiceLogModal'

type Props = {
  invoiceCurrentUsage?: franchiseInvoiceCurrentUsage
}

const Overview: React.FC<Props> = ({invoiceCurrentUsage}) => {
  const [chargesModalItemId, setChargesModalItemId] = useState<number | undefined>(undefined)

  const isInvoice = invoiceCurrentUsage?.type === 'invoice'
  const invoiceId = invoiceCurrentUsage?.invoice?.id

  return (
    <div className='card-body border-top p-9'>
      <div className='d-flex overflow-auto'>
        <table className='table table-row-dashed table-row-gray-300 gy-7'>
          <thead>
            <tr className='fw-bolder fs-6 text-gray-800'>
              {isInvoice && (
                <>
                  <th>Unidade</th>
                  <th>ResponsavelFinanceiro</th>
                </>
              )}
              <th>Descrição</th>
              <th>Quantidade</th>
              <th>Preço Unitário</th>
              <th>Total</th>
              {isInvoice && <th>Cobranças</th>}
            </tr>
          </thead>
          <tbody>
            <TableBody
              items={
                isInvoice
                  ? invoiceCurrentUsage?.invoice?.items ?? []
                  : invoiceCurrentUsage?.usage?.items ?? []
              }
              franchiseName={invoiceCurrentUsage?.invoice?.franchise?.name}
              billingEntityName={invoiceCurrentUsage?.invoice?.billingEntity?.name}
              totalAmount={
                invoiceCurrentUsage?.invoice?.totalAmount ||
                invoiceCurrentUsage?.usage?.totalAmount ||
                0
              }
              showChargesColumn={isInvoice}
              onViewCharges={isInvoice ? setChargesModalItemId : undefined}
            />
          </tbody>
        </table>
      </div>

      {chargesModalItemId !== undefined && (
        <InvoiceLogModal
          invoiceId={invoiceId}
          invoiceItemId={chargesModalItemId}
          onClose={() => setChargesModalItemId(undefined)}
        />
      )}
    </div>
  )
}

type TableBodyProps = {
  items?: any[]
  franchiseName?: string
  billingEntityName?: string
  totalAmount: number
  showChargesColumn?: boolean
  onViewCharges?: (itemId: number) => void
}
const TableBody: React.FC<TableBodyProps> = ({
  items,
  franchiseName,
  billingEntityName,
  totalAmount,
  showChargesColumn,
  onViewCharges,
}) => {
  return (
    <>
      {items?.map((item, index) => (
        <tr key={item.id ?? index}>
          {franchiseName && billingEntityName && (
            <>
              <td>{franchiseName}</td>
              <td>{billingEntityName}</td>
            </>
          )}
          <td>{item.description}</td>
          <td>{item.quantity}</td>
          <td>{formatMonetaryToBr(item.unitPrice)}</td>
          <td>{formatMonetaryToBr(item.amount)}</td>
          {showChargesColumn && (
            <td>
              {item.id !== undefined && (
                <button
                  type='button'
                  className='btn btn-sm btn-light-primary'
                  onClick={() => onViewCharges?.(item.id)}
                >
                  Ver cobranças
                </button>
              )}
            </td>
          )}
        </tr>
      ))}
      <tr>
        <td colSpan={franchiseName && billingEntityName ? 5 : 3} style={{fontWeight: 'bold'}}>
          Total a pagar:
        </td>
        <td style={{fontWeight: 'bold'}}>{formatMonetaryToBr(totalAmount)}</td>
        {showChargesColumn && <td />}
      </tr>
    </>
  )
}
export {Overview}
